import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input } from '@angular/core';
import { Chart } from 'chart.js';
@Component({
  selector: 'app-chart-line',
  templateUrl: './chart-line.component.html',
  styleUrls: ['./chart-line.component.scss']
})
export class ChartLineComponent implements OnInit, AfterViewInit {
  @ViewChild('LineChartID')
  chartID: ElementRef;
  @Input('chartType')
  chartType: string;
  @Input('labels')
  labels: any[];
  @Input('chartData')
  chartData: any[];
  @Input('legendPosition')
  legendPosition: string = 'top';
  @Input('backgroundColors')
  backgroundColors: any[] = ['#86c27c', '#ff8357', '#fedd57', '#3d1b68', '#3d1b68', '#b65bf7'];
  @Input('labelString')
  labelString: string = '';
  @Input('isLabelString')
  isLabelString: boolean = false;
  public chartLine: any;
  constructor() {}

  ngOnInit() {}
  ngAfterViewInit() {
    this.chartLoader();
  }

  chartLoader(): void {
    this.chartLine = new Chart(this.chartID.nativeElement, {
      type: this.chartType, // pie , line ,'doughnut' ....
      data: {
        labels: this.labels,
        datasets: this.chartData
      },
      options: {
        responsive: false,
        legend: {
          position: this.legendPosition
        },
        animation: {
          animateScale: true,
          defaultColor: 'rgba(152, 152, 152, 0.5)',
          onComplete: function(ctx) {}
        },
        scales: {
          xAxes: [
            {
              stacked: true
            }
          ],
          yAxes: [
            {
              stacked: false,
              scaleLabel: {
                display: this.isLabelString,
                labelString: this.labelString
              }
            }
          ]
        }
      }
    }); // Must be List // Type is string
  }
  public chartUpdate() {
    this.chartLine.resize();
    this.chartLine.update({
      duration: 800,
      lazy: true,
      easing: 'easeOutBounce'
    });
  }
}
